import {useEffect, useState} from 'react';

import {DocumentsList} from '..';
import {withDocumentsList} from '../hoc/withDocumentsList';


const filterDocuments = (documents, tabName) => {
  return documents.filter(document => (document.tabs || []).includes(tabName))
};


const BaseDocumentsLists = ({
                              controlUuid,
                              documents: originalDocuments,
  endsWithAfterControlNote,
  fetchError,
  fetchingOn,
  removingOnListForbidden
}) => {
  const [documents, setDocuments] = useState([]);

  useEffect(() => {
    // at the beginning, the list can be empty
    setDocuments(originalDocuments || []);
  }, [originalDocuments]);

  if (fetchingOn) {
    return <p className="info-text" role="status">Pobieram listę plików...</p>
  }

  if (fetchError) {
    return <p className="error-text" role="alert">Nie udało się pobrać listy plików. {fetchError}</p>
  }

  function handleRemoveDocument(documentId) {
    setDocuments(
      prevVal => prevVal.filter(document => document.id !== documentId));
  }

  return (
    <>
      <DocumentsList
        documents={filterDocuments(documents, 'ANSWER')}
        label="Pliki załączone podczas uzupełniania listy sprawdzającej"
        listId="fileListControlList"
      />
      {endsWithAfterControlNote
        ? <DocumentsList
            documents={filterDocuments(documents, 'NOTE')}
            label="Pliki załączone podczas uzupełniania notatki pokontrolnej"
            listId="fileListPostControlNote"
          />
        : (
          <>
            <DocumentsList
              documents={filterDocuments(documents, 'INFO')}
              label="Pliki załączone podczas uzupełniania informacji pokontrolnej"
              listId="fileListPostControlInfo"
            />
            <DocumentsList
              documents={filterDocuments(documents, 'FINAL_INFO')}
              label="Pliki załączone podczas uzupełniania ostatecznej informacji pokontrolnej"
              listId="fileListPostControlNoteOst"
            />
            <DocumentsList
              documents={filterDocuments(documents, 'OBJECTION')}
              label="Pliki załączone podczas uzupełniania zastrzeżeń"
              listId="fileListRemarks"
            />
          </>
        )
      }
      <DocumentsList
          canRemove={!removingOnListForbidden}
          controlUuid={controlUuid}
          documents={documents.filter(document => !document.tabs?.length)}
          label='Pliki załączone bezpośrednio poprzez akcję "Pliki"'
          onRemoveDocument={handleRemoveDocument}
          listId="fileListOthers"
      />
    </>
  )
};

export const DocumentsLists = withDocumentsList(BaseDocumentsLists);
